import { Checkbox, FormControlLabel, ListSubheader, Menu, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MainLayoutStyles from '../../styles/MainLayoutStyle';
import SearchBox from '../shared/SearchBox';

const FilterComponent = ({ handleObjChange, filter, type }) => {
  const classes = MainLayoutStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [filters, setFilters] = useState(filter);
  const [filterActive, setFilterActive] = useState(false);

  useEffect(() => {
    setFilters(filter);
  }, [filter]);
  useEffect(() => {
    handleObjChange(filters);
    filterCondition();
  }, [filters]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleTextChange = ({ target }) => {
    setFilters((f) => ({
      ...f,
      searchTerm: target.value,
    }));
  };
  const handleFilterChange = ({ target }) => {
    const filterKey = target.name;
    const check = filters[filterKey]?.some((e) => e === target.value);
    if (!check) {
      setFilters((f) => ({
        ...f,
        [filterKey]: [...f[filterKey], target.value],
      }));
    } else {
      setFilters((f) => ({
        ...f,
        [filterKey]: [...f[filterKey].filter((a) => a !== target.value)],
      }));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterCondition = () => {
    const fArr = Object.keys(filter).map((key) => filters[key]?.length === filter[key]?.length);
    const checker = fArr.every((v) => v === true);
    setFilterActive(checker);
  };
  const filterMenu = (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div>
        {Object.keys(filter).map((key) => (
          <div>
            {key !== 'searchTerm' ? <ListSubheader>{key.toUpperCase()}</ListSubheader> : null}
            {typeof filter[key] === 'object'
              ? filter[key].map((ele) => (
                  <MenuItem style={{ padding: '0px' }}>
                    <FormControlLabel
                      classes={{
                        root: classes.fullWidth,
                      }}
                      label={ele}
                      control={
                        <Checkbox
                          checked={filters[key]?.filter((item) => item === ele).length > 0}
                          name={key}
                          value={ele}
                          onChange={handleFilterChange}
                        />
                      }
                    />
                  </MenuItem>
                ))
              : []}
          </div>
        ))}
      </div>
    </Menu>
  );
  return (
    <SearchBox
      handleSearchChange={handleTextChange}
      searchVal={filters?.searchTerm}
      placeholder={`Search ${type}`}
      filterCondition={filterActive}
      menu={filterMenu}
      handleClick={handleClick}
    />
  );
};

export default FilterComponent;
